module.exports = __webpack_public_path__ + "static/media/rails.5c827de7.png";